import React from "react";

function Icon() {
  return (
    <div>
    <svg width="46" height="36" viewBox="0 0 56 52" fill="none" xmlns="http://www.w3.org/2000/svg">
    <ellipse cx="28" cy="26" rx="28" ry="26" fill="#C4C4C4"/>
    <path d="M28 18C25.7909 18 24 19.7909 24 22C24 24.2091 25.7909 26 28 26C30.2091 26 32 24.2091 32 22C32 19.7909 30.2091 18 28 18ZM22 22C22 18.6863 24.6863 16 28 16C31.3137 16 34 18.6863 34 22C34 25.3137 31.3137 28 28 28C24.6863 28 22 25.3137 22 22ZM24 32C22.3431 32 21 33.3431 21 35C21 35.5523 20.5523 36 20 36C19.4477 36 19 35.5523 19 35C19 32.2386 21.2386 30 24 30H32C34.7614 30 37 32.2386 37 35C37 35.5523 36.5523 36 36 36C35.4477 36 35 35.5523 35 35C35 33.3431 33.6569 32 32 32H24Z" fill="#0D0D0D"/>
    </svg>
    
    </div>
  );
}

export default Icon;
